import { useCallback, useMemo, createContext, useEffect, useState } from 'react';
// import config from '/config'

// Context
import { useStorage } from '@wearetla/tla-essentials-tools/utilities/storage';

// Services
import branchServices from '/services/branch';

export const BranchSelectionContext = createContext({
	selectedBranch: null,
	initialized: false,
	branches: [],
	submitMenuUrl: () => {},
});

export const BranchSelectionProvider = ({ children }) => {
	const [selectedBranchData, setSelectedBranchData] = useState(null);
	const { branchSlug, tableNumber, setData } = useStorage();
	const [initialized, setInitialized] = useState(false);

	const branchTableTitle = useMemo(() => {
		let title = selectedBranchData?.title ?? 'Şube Getiriliyor...';

		if (selectedBranchData && tableNumber) {
			title += ` - Masa ${tableNumber}`;
		}

		return title;
	}, [selectedBranchData, tableNumber]);

	useEffect(() => {
		if (branchSlug && branchSlug !== selectedBranchData?.slug) {
			branchServices
				.getBranch(branchSlug)
				.then((branchData) => {
					setSelectedBranchData(branchData);
				})
				.catch(() => {
					setData('branchSlug', false);
					setData('tableNumber', false);
				})
				.finally(() => {
					setInitialized(true);
				});
		} else if (!branchSlug) {
			setData('tableNumber', false);
			setSelectedBranchData(null);
			setInitialized(true);
		}
	}, [branchSlug, selectedBranchData]);

	const setTableNumber = (tableNumber) => {
		setData('tableNumber', (!!tableNumber && !isNaN(tableNumber)) ? tableNumber : false);
	}

	const setActiveBranch = useCallback((branchSlug, tableNumber) => {
		return new Promise((resolve, reject) => {
			branchServices
					.getBranch(branchSlug)
					.then((branchData) => {
						setSelectedBranchData(branchData);
						setData('branchSlug', branchSlug);
						setTableNumber(tableNumber);
						resolve(branchData);
					})
					.catch((e) => {
						reject(e);
					});
		})
	});

	const checkoutEnabled = useMemo(() => !!selectedBranchData?.online_sale, [selectedBranchData]);

	const submitMenuUrl = useCallback((menuUrl) => {
		return new Promise((resolve, reject) => {
			const cleanUrl = menuUrl
				.split('?')[0]
				.replace('//', '')
				.replace(/^\/|\/$/g, '');
			const urlFragments = cleanUrl.split('/');

			if(urlFragments.length === 3 && urlFragments[1] === 'ifsokaksogutozu') {
				const branchSlug = urlFragments[1];
				const tableNumber = urlFragments[2] ?? false;

				setActiveBranch(branchSlug, tableNumber).then(resolve).catch(reject);
			}
			else if (urlFragments.length === 4 || urlFragments.length === 3) {
				const branchSlug = urlFragments[2];
				const tableNumber = urlFragments[3] ?? false;

				setActiveBranch(branchSlug, tableNumber).then(resolve).catch(reject);
			}
			else {
				reject('Hatalı bir QR okuttunuz.');
			}
		});
	}, []);

	const api = useMemo(
		() => ({
			selectedBranch: selectedBranchData,
			setActiveBranch,
			submitMenuUrl,
			tableNumber,
			setTableNumber,
			initialized,
			branchTableTitle,
			checkoutEnabled,
		}),
		[selectedBranchData, submitMenuUrl, tableNumber, branchTableTitle, initialized]
	);

	return <BranchSelectionContext.Provider value={api}>{children}</BranchSelectionContext.Provider>;
};
